/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTreatmentTemplates } from 'app/entities/treatment-template/treatment-template.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-delivery-plan.reducer';

export const TreatmentDeliveryPlanUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const treatmentTemplates = useAppSelector(state => state.treatmentTemplate.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const treatmentDeliveryPlanEntity = useAppSelector(state => state.treatmentDeliveryPlan.entity);
  const loading = useAppSelector(state => state.treatmentDeliveryPlan.loading);
  const updating = useAppSelector(state => state.treatmentDeliveryPlan.updating);
  const updateSuccess = useAppSelector(state => state.treatmentDeliveryPlan.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-delivery-plan${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTreatmentTemplates({}));
    dispatch(getGlucoUsers({}));
    dispatch(getDoctors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentDeliveryPlanEntity,
      ...values,
      template: treatmentTemplates.find(it => it.id.toString() === values.template?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      physician: doctors.find(it => it.id.toString() === values.physician?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentDeliveryPlanEntity,
          template: treatmentDeliveryPlanEntity?.template?.id,
          patient: treatmentDeliveryPlanEntity?.patient?.id,
          physician: treatmentDeliveryPlanEntity?.physician?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.treatmentDeliveryPlan.home.createOrEditLabel" data-cy="TreatmentDeliveryPlanCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.treatmentDeliveryPlan.home.createOrEditLabel">
              Create or edit a TreatmentDeliveryPlan
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-delivery-plan-id"
                  label={translate('tinyMedicRestApp.treatmentDeliveryPlan.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDeliveryPlan.startDate')}
                id="treatment-delivery-plan-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDeliveryPlan.endDate')}
                id="treatment-delivery-plan-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDeliveryPlan.status')}
                id="treatment-delivery-plan-status"
                name="status"
                data-cy="status"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDeliveryPlan.active')}
                id="treatment-delivery-plan-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDeliveryPlan.cursor')}
                id="treatment-delivery-plan-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDeliveryPlan.lastUpdated')}
                id="treatment-delivery-plan-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDeliveryPlan.microSec')}
                id="treatment-delivery-plan-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDeliveryPlan.timestampEntry')}
                id="treatment-delivery-plan-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="treatment-delivery-plan-template"
                name="template"
                data-cy="template"
                label={translate('tinyMedicRestApp.treatmentDeliveryPlan.template')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentTemplates
                  ? treatmentTemplates.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-delivery-plan-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.treatmentDeliveryPlan.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-delivery-plan-physician"
                name="physician"
                data-cy="physician"
                label={translate('tinyMedicRestApp.treatmentDeliveryPlan.physician')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/treatment-delivery-plan" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentDeliveryPlanUpdate;
